import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import DropdownCustomFieldForm from '@/features/dashboard/tourCustomFields/components/DropdownCustomFieldForm.tsx';
import {
  DropdownCustomFieldFormData,
  DropdownCustomFieldInputData,
  dropdownCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/dropdownCustomFieldSchema.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { DropdownCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/DropdownCustomFieldDefinitionDto.ts';
import useUpdateCustomField from '@/features/dashboard/tourCustomFields/hooks/useUpdateCustomField.ts';

const DropdownCustomFieldEditModal = ({
  onClose,
  fieldDef,
}: {
  onClose: () => void;
  fieldDef: DropdownCustomFieldDefinitionDto;
}) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<DropdownCustomFieldInputData>({
    resolver: debugZodResolver(dropdownCustomFieldSchema),
    defaultValues: {
      type: FieldType.DROPDOWN,
      fieldName: fieldDef.name,
      isFieldMandatory: fieldDef.required,
      placeholder: fieldDef.placeholder,
      hint: fieldDef.hint,
      options: fieldDef.options,
    },
  });

  const updateCustomField = useUpdateCustomField(tourId, fieldDef.id);

  const handleSubmit = (data: DropdownCustomFieldFormData) => {
    updateCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Edytuj pole wybór jednokrotny" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <DropdownCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Zapisz
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default DropdownCustomFieldEditModal;
